const GROUP_FIELDS = {
  Melodies: 'melody_loop_ids', Drums: 'drum_loop_ids',
  Textures: 'texture_loop_ids', 'Sound FX': 'sfx_loop_ids',
};

// Never turn a failed request into a missing membership entry.
export async function loadCompletePackLoops(pack, loadLoop) {
  const groups = await Promise.all(Object.entries(GROUP_FIELDS).map(async ([group, field]) => {
    const ids = pack[field] ?? [];
    if (!Array.isArray(ids)) throw new Error('Invalid pack membership');
    const loops = await Promise.all(ids.map(async (id) => {
      const loop = await loadLoop(id);
      if (!loop || loop.loop_id !== id) throw new Error('Missing or mismatched pack sound');
      return loop;
    }));
    return [group, loops];
  }));
  return Object.fromEntries(groups);
}
